import React from 'react'
import PropTypes from 'prop-types'
import { Transition, animated } from 'react-spring/renderprops'
import { X } from '@entrata/portals-common/lib/icons'

import styled from '@emotion/styled'

const StyledDiv = animated(styled('div')`
  width: 100%;
  background: ${({ theme }) => theme.mode.side_panel_background};
  border-top: 1px solid ${({ theme }) => theme.mode.card_border_color};
  color: ${({ theme }) => theme.text.white};
  padding: 16px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: row;

  @media only screen and (min-width: 768px) {
    padding: 0 48px;
  }
`)

const StyledButton = styled('button')`
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.text.white};
  transition: background 250ms ease-in-out;
  @media only screen and (max-width: 500px) {
    align-self: self-start;
  }
`

const NoticeWrapper = ({ show, children, onClose, size = 28 }) => (
  <Transition
    items={show}
    from={{ opacity: 0, transform: 'translateY(100px)' }}
    enter={{ opacity: 1, transform: 'translateY(0px)' }}
    leave={{ opacity: 0, transform: 'translateY(100px)' }}
    native
  >
    {show =>
      show &&
      (styles => (
        <StyledDiv style={styles}>
          {children}
          {typeof onClose === 'function' && (
            <StyledButton onClick={onClose}>
              <X size={size} />
            </StyledButton>
          )}
        </StyledDiv>
      ))
    }
  </Transition>
)

NoticeWrapper.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.any.isRequired,
  onClose: PropTypes.func,
  size: PropTypes.number,
}

export default NoticeWrapper
